module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bh-upload-wrap"
  }, [(_vm.readOnly && _vm.fileData.length === 0) ? _c('mt-cell', {
    attrs: {
      "title": _vm.label,
      "readonly": _vm.readOnly,
      "titlewidth": _vm.titlewidth,
      "value-align": _vm.textalign
    }
  }) : _vm._e(), _vm._v(" "), ((!_vm.readOnly) || (_vm.readOnly && _vm.fileData.length > 0)) ? _c('mt-cell', {
    staticClass: "is-vertical mint-uploadimgs",
    attrs: {
      "readonly": _vm.readOnly,
      "title": _vm.label,
      "disabledcolor": _vm.disabled,
      "required": _vm.required,
      "titlewidth": _vm.titlewidth,
      "value-align": _vm.textalign
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_vm._l((_vm.fileData), function(item, index) {
    return [(_vm.isImage(item) === true) ? [_c('div', {
      staticClass: "upload_item"
    }, [(!_vm.readOnly) ? _c('i', {
      staticClass: "iconfont icon-weiwancheng cancel_upload_img",
      on: {
        "click": function($event) {
          _vm.deleteImg(item.id)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('img', {
      staticClass: "upload_img",
      attrs: {
        "src": _vm.getFileByUrl(item.fileUrl),
        "alt": ""
      },
      on: {
        "click": function($event) {
          _vm.previewImg(index)
        }
      }
    })])] : _vm._e(), _vm._v(" "), (_vm.isImage(item) === false) ? [_c('div', {
      staticClass: "upload_item"
    }, [(!_vm.readOnly) ? _c('i', {
      staticClass: "iconfont icon-weiwancheng cancel_upload_img",
      on: {
        "click": function($event) {
          _vm.deleteImg(item.id)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('a', {
      attrs: {
        "href": item.fileUrl
      }
    }, [_c('i', {
      staticClass: "iconfont",
      class: _vm.getFileType(item),
      staticStyle: {
        "font-size": "75px"
      },
      on: {
        "click": function($event) {
          _vm.previewFile(item)
        }
      }
    })])])] : _vm._e()]
  }), _vm._v(" "), (_vm.fileData.length < _vm.maxNumber && !_vm.readOnly) ? [_c('div', {
    staticClass: "upload_item"
  }, [_c('img', {
    staticClass: "upload_img",
    attrs: {
      "src": require("../../static/img/upload.png"),
      "alt": "无"
    },
    on: {
      "click": _vm.handleClick
    }
  })])] : _vm._e()], 2), _vm._v(" "), _c('mt-actionsheet', {
    attrs: {
      "actions": _vm.materialActions
    },
    model: {
      value: (_vm.materialSheetVisible),
      callback: function($$v) {
        _vm.materialSheetVisible = $$v
      },
      expression: "materialSheetVisible"
    }
  })], 1)
},staticRenderFns: []}


// WEBPACK FOOTER //
// ./src/components/emapm-upload-imgs.vue